import { Table, TableCell, TableHead, TableRow } from "@mui/material";
import React from "react";

const NestedColumns = (props) => {
  const { columns, commonStyle, config } = props;

  const { isViewMode, needNestedActions = true } = config;

  const getFinalColumns = (columns = []) => {
    const isLast = columns.find((col) => col.type === "nested") ?? false;
    const finalIndex = columns.length - 1;
    return columns.map((column, idx) => {
      if (column?.type !== "nested") {
        return (
          <>
            <TableCell
              key={idx}
              sx={{
                ...commonStyle.tableCell,
                ...(column?.sx ? column?.sx : {}),
              }}
            >
              {column?.name}
            </TableCell>
            {!isLast &&
              needNestedActions &&
              finalIndex === idx &&
              !isViewMode && (
                <TableCell sx={{ ...commonStyle.tableCell }}>Actions</TableCell>
              )}
          </>
        );
      } else {
        return (
          <>
            {!isViewMode && needNestedActions && (
              <TableCell sx={{ ...commonStyle.tableCell }}>Actions</TableCell>
            )}
            <TableCell key={idx} sx={{ ...commonStyle.tableCell }}>
              <Table size="small">
                <TableHead sx={{ border: "none" }}>
                  <TableRow>{getFinalColumns(column?.value)}</TableRow>
                </TableHead>
              </Table>
            </TableCell>
          </>
        );
      }
    });
  };

  return (
    <TableRow>
      {getFinalColumns(columns)}
      {(needNestedActions && !isViewMode) ||
      (!needNestedActions &&
        config?.alwaysShowActions &&
        config?.actions?.length > 0) ? (
        <TableCell sx={{ ...commonStyle.tableCell }}>Actions</TableCell>
      ) : null}
    </TableRow>
  );
};

export default NestedColumns;
